import {startTypeShuffle, toggleModalSketch, utils} from "../components/utils";
import {gsapContext} from "../components/theme-scripts";

export function templateExperienceInit() {

	gsapContext.add(() => {

		document.body.addEventListener('preloadcomplete', function () {

			const section = document.querySelector('section');
			const lock = document.querySelector('.lock');

			if (document.body.classList.contains('logged-in'))
			{
				setTimeout(function () {
					lock.classList.add('unlocked-1');
				}, 600);

				setTimeout(function () {
					lock.classList.add('unlocked-2');
				}, 1100);

				setTimeout(function () {
					lock.classList.add('hidden');
				}, 2600);

				setTimeout(function () {
					section.classList.add('trigger-1');

					startTypeShuffle(section);
				}, 2900);
			}
			else
			{
				setTimeout(function () {
					lock.classList.add('locked');
				}, 600);
			}

		});

	});

}